(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('moment-timezone')) :
  typeof define === 'function' && define.amd ? define(['moment-timezone'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.hstri = factory(global.moment));
}(this, (function (moment) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);

      if (enumerableOnly) {
        symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
      }

      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ajax(_ref) {
    var url = _ref.url,
        data = _ref.data,
        method = _ref.method,
        headers = _ref.headers;
    var promise = fetch(url, {
      method: method.toUpperCase(),
      headers: _objectSpread2({
        'Content-Type': 'application/json; charset=UTF-8'
      }, headers),
      body: JSON.stringify(data)
    }).then(function (response) {
      return response.json();
    });
    return promise;
  }

  function queryMichelangelo (opts) {
    var data = buildQuery({
      timeFrame: opts.timeFrame,
      start: opts.start,
      end: opts.end,
      series: opts.instrument,
      frequency: opts.frequency,
      entitlementToken: opts.entitlementToken,
      volume: opts.volume
    });
    var promise = sendQuery(data)["catch"](function (err) {
      if (err.responseJSON && err.responseJSON.Message) {
        throw 'Message from API: ' + err.responseJSON.Message;
      }

      throw err.statusText;
    });

    if (opts.raw !== true) {
      promise = promise.then(extractValues).then(combineValues).then(extractMetadata$1)["catch"](function (err) {
        console.error(err);
        throw 'Error parsing data';
      }); // .then(fillBlanks);
    }

    if (opts.callback) {
      promise.then(opts.callback);
    }

    return promise;
  }

  function extractValues(data) {
    return data.Series.map(function (d, i) {
      return {
        points: d.DataPoints.map(function (p, j) {
          var points = {};
          d.DesiredDataPoints.forEach(function (dataPointType, k) {
            points[dataPointType] = p[k];
          });
          return points;
        }),
        ticks: data.TimeInfo.Ticks,
        raw: data
      };
    });
  }

  function combineValues(data) {
    return data.map(function (d, i) {
      var combined = d.points.map(function (p, j) {
        p.date = d.ticks[j];
        return p;
      });
      d.data = combined.map(function (p) {
        return [p.date, p.Last ? p.Last : p.Volume];
      });
      d.fullData = combined;
      return d;
    });
  }

  function extractMetadata$1(data) {
    return data.map(function (d, i) {
      var raw = d.raw.Series[i];
      d.ticker = raw.Ticker;
      d.name = raw.CommonName;
      return d;
    });
  }
  /*
  opts:
  - start (date)
  - end (date)
  - series (array of instrument keys)
  */


  function buildQuery(opts) {
    var series = opts.series.map(function (symbol) {
      var props = {
        "Key": symbol,
        "Dialect": "Charting",
        "Kind": "Ticker",
        "SeriesId": "s1",
        "DataTypes": ["Open", "High", "Low", "Last", "PercentChange"]
      };

      if (opts.volume) {
        props["Indicators"] = [{
          "Parameters": [],
          "Kind": "Volume",
          "SeriesId": "i2"
        }];
      }

      return props;
    });
    return {
      "Series": series,
      "StartDate": opts.start ? opts.start.valueOf() : null,
      "EndDate": opts.end ? opts.end.valueOf() : null,
      "Step": opts.frequency,
      // "TimeFrame":"D1",
      "EntitlementToken": opts.entitlementToken,
      "IncludeMockTick": true,
      "FilterNullSlots": true,
      "FilterClosedPoints": true,
      "IncludeClosedSlots": false,
      "IncludeOfficialClose": true,
      "InjectOpen": false,
      "ShowPreMarket": false,
      "ShowAfterHours": false,
      "UseExtendedTimeFrame": true,
      "WantPriorClose": true,
      "IncludeCurrentQuotes": true,
      "ResetTodaysAfterHoursPercentChange": false,
      "TimeFrame": opts.timeFrame
    };
  }

  function sendQuery(data) {
    var request = ajax({
      url: "https://api.wsj.net/api/michelangelo/timeseries/history?ckey=".concat(data.EntitlementToken.slice(0, 10)),
      method: 'POST',
      data: data,
      headers: {
        "Dylan2010.EntitlementToken": data.EntitlementToken
      }
    });
    return request;
  }

  function queryDylan (opts) {
    var query = buildQuery(opts);
    var url = "https://api.wsj.net/api/dylan/dataseries/v2/pricing?id='".concat(query, "'&ckey=57494d5ed7&Dylan2010.EntitlementToken=").concat(opts.entitlementToken, "&json=true");
    var promise = ajax({
      url: url,
      method: 'GET',
      crossDomain: true,
      headers: {
        Accept: 'application/json',
        'Dylan2010.EntitlementToken': opts.entitlementToken
      }
    })["catch"](function (err) {
      console.error(err);

      if (typeof $ !== 'undefined') {
        var message = $(err.responseText).find('p:eq(1)').text().split("'")[1];
        throw 'Message from API: ' + message;
      } else {
        throw err.responseText;
      }
    });

    if (opts.raw !== true) {
      promise = promise.then(extractValues).then(processValues).then(extractMetadata)["catch"](function (err) {
        console.error(err);
        throw 'Problem parsing data';
      });
    }

    if (opts.callback) {
      promise.then(opts.callback);
    }

    return promise;

    function extractValues(d) {
      var metadata = d.GetDataSeriesResponse.DataSeriesResponses[0].SeriesMatches[0];
      var values = metadata.DataPoints;

      if (values.length === 0) {
        throw 'Live data is empty.';
      }

      return {
        metadata: metadata,
        values: values
      };
    }

    function processValues(_ref) {
      var metadata = _ref.metadata,
          values = _ref.values;
      var processed = values.map(function (d, i) {
        var date = Date.parse(d.Trading.Last.Time);
        var value = d.Trading.Last.Price.Value;
        return [date, value];
      });
      return [{
        raw: metadata,
        data: processed
      }];
    }

    function buildQuery(opts) {
      /*
          Instruments --> comma separated list of instruments to request formated as follows
          Ticker|CountryCode|ExchangeIsoCode|InstrumentType
           Needed --> pipe separated list of what you want returned possibilities
          AfterHoursTrading, BeforeHourseTrading, Financials, FinancialStatusIndicator, Offers, Trading, TradingStatistics, RealtimeTrading, RealtimeBeforeHoursTrading, RealTimeAfterHoursTrading, CompositeTrading, CompositeBeforeHoursTrading, CompositeAfterHoursTrading, IndustryClassification, BluegrassChannels, TimeZoneInfo, BondSpecific, CurrencySpecific)
          */
      var query = '';
      query += opts.instrument[0] + '|'; // Ticker|CountryCode|ExchangeIsoCode|InstrumentType

      query += opts.start.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
      query += opts.end.format('YYYY-MM-DD[T]HH:mm:ss') + '|';
      query += opts.frequency + '||True';
      return query; // EURUSD|US||Currency|'+range[0]+ '|' +range[1] + '|PT1M||True
    }
  }

  function extractMetadata(data) {
    var raw = data[0].raw.Instrument;
    data[0].name = raw.CommonName;
    data[0].ticker = raw.Ticker;
    return data;
  }

  function fillBlanksWith (_ref) {
    var frequency = _ref.frequency,
        fillBlanksWithPrevious = _ref.fillBlanksWithPrevious,
        start = _ref.start,
        end = _ref.end;
    return function (arr) {
      var precisions = {
        P1D: 'day',
        P1Y: 'year',
        P1W: 'week',
        PT1M: 'minute',
        PT1H: 'hour'
      };
      var intervals = {};
      Object.keys(precisions).forEach(function (k) {
        intervals[k] = moment__default['default']() - moment__default['default']().subtract(1, precisions[k]);
      });
      var interval = intervals[frequency];
      arr.forEach(function (instr) {
        var data = JSON.parse(JSON.stringify(instr.data));
        var lengthOfTime = end - start;
        var expectedNumberOfTicks = lengthOfTime / interval;
        var expectedTicks = [];

        for (var i = 0; i < expectedNumberOfTicks; i++) {
          expectedTicks.push([start + interval * i, null]);
        }

        var fullTicks = [].concat(data, expectedTicks);
        fullTicks.sort(function (a, b) {
          return a[0] - b[0];
        });
        fullTicks.forEach(function (d) {
          d[0] = moment__default['default'].utc(d[0]).startOf(precisions[frequency]).valueOf();
        });
        var uniqueTicks = fullTicks.reduce(function (accum, curr, i) {
          var existingIndex = -1;
          var existing = accum.filter(function (d, i) {
            if (d[0] === curr[0]) {
              existingIndex = i;
            }

            return d[0] === curr[0];
          });

          if (existing.length === 0) {
            accum.push([curr[0], curr[1]]);
          } else if (existingIndex > -1 && existing[0][1] === null) {
            accum[existingIndex] = curr;
          }

          return accum;
        }, []);
        var fillWithPreviousValue = createFillerBackTo(instr.ticks[instr.ticks.length - 1]);

        if (fillBlanksWithPrevious) {
          uniqueTicks = uniqueTicks.map(fillWithPreviousValue);
        }

        instr.data = uniqueTicks;
        instr.ticks = uniqueTicks.map(function (d) {
          return d[0];
        });
        instr.points = uniqueTicks.map(function (d) {
          return d[1];
        });
      });
      return arr;
    };

    function createFillerBackTo(d) {
      var date = moment__default['default'](d);
      return function (d, i, arr) {
        var notFirst = i > 0;
        var isNull = d[1] === null;
        var inPast = moment__default['default'].utc(d[0]).isBefore(date);

        if (notFirst && isNull && inPast) {
          d[1] = arr[i - 1][1];
        }

        return d;
      };
    }
  }

  var hstri = function hstri(opts) {
    opts = processOpts(opts);
    var promise;

    if (opts.service === 'dylan') {
      promise = queryDylan(opts);
    } else {
      promise = queryMichelangelo(opts);
    }

    if (opts.fillBlanks || opts.fillBlanksWithPrevious) {
      var fillBlanks = fillBlanksWith(opts);
      promise = promise.then(fillBlanks);
    }

    if (opts.raw !== true) {
      promise = promise.then(addSource(opts));
    }

    return promise;
  };

  function validateFrequency(frequency) {
    // regex from moment.js
    // https://github.com/moment/moment/blob/develop/src/lib/duration/create.js#L14
    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
    var match = frequency.match(isoRegex);

    if (match === null || !frequency) {
      throw '"' + frequency + '" option is not valid. Here are some example time codes:\
P1D  | daily\
P1Y  | yearly\
P1W  | weekly\
PT1M | every minute\
PT1H | every hour\
';
    }
  }

  function processOpts(opts) {
    var roundToNearestMinute = createMinuteRounder(moment__default['default']);

    if (!opts.instrument) {
      throw 'No symbol specified';
    }

    if (Array.isArray(opts.instrument) === false) {
      opts.instrument = [opts.instrument];
    }

    if (opts.timeFrame === 'custom' || !opts.timeFrame) {
      if (!opts.start) {
        throw 'Must specify start date or time frame code';
      } else {
        checkDate(opts.start, 'Start date');
      }

      if (opts.end) {
        checkDate(opts.end, 'End date');
      } else {
        opts.end = moment__default['default']();
      }

      if (opts.start.isSame(opts.end)) {
        if (opts.start.format('HH:mm:ss') === '00:00:00') {
          // if both dates are midnight, assume user wants that full day
          opts.end.endOf('day');
        } else {
          throw 'Start and end dates are exactly the same day and time.';
        }
      }

      opts.start = roundToNearestMinute(opts.start);
      opts.end = roundToNearestMinute(opts.end, true);
      opts.timeFrame = 'custom';
    } else {
      opts.start = '';
      opts.end = '';
    }

    validateFrequency(opts.frequency);
    return opts;
  }

  function checkDate(date, name) {
    if (moment__default['default'].isMoment(date) === false) {
      throw name + ' is not a Moment.js date object. It also needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
    }

    if (date.tz() === undefined) {
      throw name + ' needs a timezone explicitly set using the Moment Timezone plugin. Downloads and documentation here: http://momentjs.com/timezone/';
    }

    return true;
  }

  function createMinuteRounder(moment) {
    return function roundToNearestMinute(date) {
      var roundUp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var roundToNearest = 60000; // 1 minutes

      if (roundUp) {
        return moment(Math.ceil(date / roundToNearest) * roundToNearest);
      }

      return moment(Math.floor(date / roundToNearest) * roundToNearest);
    };
  }

  function addSource(opts) {
    return function (data) {
      data.forEach(function (d) {
        d.source = {
          entitlementToken: opts.entitlementToken
        };
      });
      return data;
    };
  }

  function log(data) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'json';
    var fmt = format.toLowerCase();
    var output = '';

    if (fmt === 'raw') {
      output = JSON.stringify(data);
    } else if (fmt === 'csv') {
      console.log(arrayToCSV(data.data));
    } else {
      output = JSON.stringify(data.data);
    }

    console.log(output);
    return output;
  }

  function arrayToCSV(data) {
    var newArr = data.map(function (d, i) {
      d[0] = moment__default['default'].tz(d[0], 'America/New_York').format('DD-MM-YY HH:mm:ss');
      return d.join(",");
    });
    newArr.unshift('date,value');
    return newArr.join("\n");
  }

  hstri.log = log;

  return hstri;

})));
